


























import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from "vue-property-decorator"

@Component({})
  export default class AccordionCardWidgetComponent extends Vue {

    @Prop() isOpen!:boolean
    @Prop() title!:string
    @Prop() index!:number
    @Prop() isWizardMode!:boolean
  }

